import React from 'react';
import classes from "./LoginPage.module.css";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FaChevronRight, FaCopyright } from 'react-icons/fa6';
import { useState } from 'react';
import { loginApi } from '../http/http';
import { useEffect } from 'react';
import { v4 as uuidv4 } from "uuid";
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { setUserDetails } from '../store/slices/userSlice';

const LoginPage = () => {
    const [msisdn, setMsisdn] = useState("");
    const [loginLoading, setLoginLoading] = useState(false);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [extRef, setExtRef] = useState(null);
    const dispatch = useDispatch();

    const { userDetails } = useSelector(state => state?.persisted?.userSlice);

    useEffect(() => {
        if (userDetails?.token) {
            navigate("/home");
        }
    }, [userDetails]);

    useEffect(() => {
        if (searchParams.get("ext_ref")) {
            setExtRef(searchParams.get("ext_ref"));
        } else {
            setSearchParams({ ext_ref: uuidv4() });
        }
    }, [searchParams]);
    const handleFormSubmission = async (e) => {
        try {
            e.preventDefault();
            if (msisdn?.trim().length == 0) {
                return;
            }
            setLoginLoading(true);

            let msisdnWithCountryCode = msisdn?.toString().trim().replace(/\D/g, '');

            if (msisdnWithCountryCode.startsWith('0')) {
                msisdnWithCountryCode = msisdnWithCountryCode.slice(1);
            }

            if (!msisdnWithCountryCode.startsWith('94')) {
                msisdnWithCountryCode = '94' + msisdnWithCountryCode;
            }

            const response = await loginApi(msisdnWithCountryCode);
            console.log(response, 'response');
            dispatch(setUserDetails(response?.data?.result));
            setLoginLoading(false);
            toast.success("Login Successfully!");
            navigate("/home");
        } catch (error) {
            setLoginLoading(false);
            console.log(error, 'error');

            if (error?.response?.data?.error?.status == 0) {
                toast.error("You are not Subscribed!");
            }
            else if (error?.response?.data?.error?.status == 1) {
                toast.error("Low Balance! You have not been charged!");
            }
            else {
                toast.error("Something Went Wrong! Try Again!");
            }
        }
    }

    return (
        <main className={classes.main}>
            <header className={classes.header}>
                <nav className={classes.nav}>
                    <div className={classes.logo_container}>
                        <img src="/assets/images/logo.png" alt="logo" className={classes.logo} />
                    </div>

                    <div className={classes.nav_items}>
                        <button type="button" className={classes.nav_item_btn}
                            onClick={() => navigate(`/subscribe?ext_ref=${extRef}`)}
                        >
                            Subscribe
                        </button>
                    </div>
                </nav>
            </header>


            <section className={classes.section_landing_page}>
                <div className={classes.grid_container}>
                    <div className={classes.grid_section_one}>
                        <form className={classes.form} onSubmit={handleFormSubmission}
                        >
                            <div className={classes.username_field_form}>
                                <div className={classes.country_code}>
                                    <img src="/assets/images/sri-lanka.png" alt="flag" className={classes.flag} />
                                    <p className={classes.country_code_number}>+94</p>
                                </div>
                                <input
                                    id="msisdn"
                                    name="msisdn"
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    autoFocus placeholder={"Enter your phone number"} className={classes.input_field_username}
                                    onChange={(e) => {
                                        setMsisdn(e.target.value)
                                    }}
                                    value={msisdn}
                                />
                            </div>

                            <div className={classes.check_box_container}>
                                <input type="checkbox" id="terms" name="Terms & Conditions" value="Terms"
                                    className={classes.check_box} checked
                                >
                                </input>
                                <label for="terms" className={classes.check_box_label}>
                                    By logining in, you agree to our <span className={classes.terms_conditions}>Terms & Conditions</span>
                                </label>
                            </div>

                            <button type="submit"
                                disabled={loginLoading}
                                className={classes.login_btn}>{
                                    loginLoading ? "Please Wait...." : "Login"
                                }</button>

                            {/* <div className={classes.footer}> */}
                            {/* </div> */}
                        </form>

                    </div>
                    <div className={classes.grid_section_two}>
                        <img src="/assets/images/kids-group.png" alt="kids-group" className={classes.kids_group_image} />


                        <p className={classes.portal_description}>
                            Online educational platform for digital skills where students aged between 2-10 learn through fun and interactive videos
                        </p>

                        <div className={classes.grid_sub_container}>
                            <div className={classes.kids_image_container}>
                                <img src="/assets/images/kids.png" alt="kids" className={classes.kids_image} />
                            </div>
                            <div className={classes.kids_info}>
                                <p className={classes.kids_info_text_one}>Made For</p>
                                <p className={classes.kids_info_text_two}>- Kids</p>
                            </div>
                        </div>
                    </div>

                </div>
                <img src="/assets/images/Union.png" alt="union" className={classes.union_image} />
                <img src="/assets/images/learning.png" alt="union" className={classes.learning_image} />

            </section>

            <section className={classes.footer}>
                <div className={classes.container}>
                    <div className={classes.footer_container}>
                        <div className={classes.footer_logo_container}>
                            <img src="/assets/images/logo.png" alt="logo" className={classes.footer_logo} />
                        </div>

                        <div className={classes.copyright_container}>
                            <FaCopyright className={classes.copyright_icon} />
                            <p className={classes.copyright_text}>
                                Rainboo Softmate Pvt Ltd
                            </p>
                        </div>
                    </div>


                </div>
            </section>

        </main>

    )
}

export default LoginPage